import { c as _c } from "react/compiler-runtime";
import { useState, useEffect, type JSX } from 'react';
import type React from 'react';
interface Props {
  fallback?: JSX.Element | null;
  children: React.ReactNode;
}

/**
 * Prevent rendering the children when it's rendered on the server. Optionally
 * render a fallback instead.
 */
export function SSRBoundary(props) {
  const $ = _c(2);
  const {
    fallback: t0,
    children
  } = props;
  const fallback = t0 === undefined ? null : t0;
  const [isClient, setIsClient] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsClient(true);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  if (!isClient) {
    if (fallback) {
      return fallback;
    }
    return null;
  }
  return children as JSX.Element;
}